export const skills = [
  { id: 1, name: "ReactJS" },
  { id: 2, name: "React Native" },
  { id: 3, name: "JavaScript" },
  { id: 4, name: "TypeScript" },
  { id: 5, name: "HTML" },
  { id: 6, name: "CSS" },
  { id: 7, name: "UI/UX Design" },
  { id: 8, name: "Git/GitHub" },
  { id: 9, name: "MySQL" },
  { id: 10, name: "Tailwind" },
  { id: 10, name: "Figma" },
];
